import type {
  EditorsPicksListItem,
  SuccessApiResponseBody,
} from '@/redux/actions/editorsPicksActions';
import type {RootState} from '../store';
import type {StatusType, ReduxAction} from './typings';

import {
  STATUS_IDLE,
  STATUS_LOADING,
  STATUS_SUCCEEDED,
  STATUS_FAILED,
  LOAD_EDITORS_PICKS_REQUEST,
  LOAD_EDITORS_PICKS_FAILURE,
  LOAD_EDITORS_PICKS_SUCCESS,
} from '../actionTypes';

type EditorsPicksActionTypes =
  | typeof LOAD_EDITORS_PICKS_REQUEST
  | typeof LOAD_EDITORS_PICKS_SUCCESS
  | typeof LOAD_EDITORS_PICKS_FAILURE;

export interface EditorsPicksState {
  status: StatusType;
  data: EditorsPicksListItem[];
  error: null | string;
}

export const initialState: EditorsPicksState = {
  status: STATUS_IDLE,
  data: [],
  error: null,
};

const editorsPicksReducer = (
  state = initialState,
  action: ReduxAction<SuccessApiResponseBody, EditorsPicksActionTypes>,
) => {
  switch (action.type) {
    case LOAD_EDITORS_PICKS_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
        error: null,
      };

    case LOAD_EDITORS_PICKS_SUCCESS:
      return {
        ...state,
        status: STATUS_SUCCEEDED,
        data: action.response?.data.results as EditorsPicksListItem[],
      };

    case LOAD_EDITORS_PICKS_FAILURE:
      return {
        ...state,
        status: STATUS_FAILED,
        error: action.error?.message as string,
      };

    default:
      return state;
  }
};

export const selectEditorsPicks = (state: RootState) => state.editorsPicks;

export default editorsPicksReducer;
